import React from "react";
import { Form, Button, Header, Segment } from "semantic-ui-react";
import { Field, reduxForm } from "redux-form";
let HotelWizardComponent = props => {
  const { handleSubmit } = props;
  return (
    <React.Fragment>
      <Header as="h1">{props.t("hotel:createHotelText")}</Header>
      <Segment>
        <Form as="form" size="large" onSubmit={handleSubmit}>
          <Field
            name="hotelName"
            type="text"
            component={Form.Input}
            fluid
            placeholder={props.t("hotel:hotelsNameText")}
            label={props.t("hotel:hotelsNameText")}
          />

          <Button
            color="blue"
            type="submit"
            loading={props.fetching}
            disabled={props.fetching}>
            {props.t("hotel:createHotelText")}
          </Button>
        </Form>
      </Segment>
    </React.Fragment>
  );
};
export const HotelWizard = reduxForm({
  form: "hotel"
})(HotelWizardComponent);



// WEBPACK FOOTER //
// ./src/hotels/Wizard/HotelWizard.js